import {PageOverlayer} from '../../../../components/PageOverlayer'
import {Header} from './components/header/Header'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider, useQueryResponseLoading} from './core/QueryResponseProvider'
import {FilterProvider} from './FilterProvider'
import {Table} from './table/Table'

interface Props {
  invoiceId?: number
  invoiceItemId?: number
}

const UsageByPeriodListPage = ({invoiceId, invoiceItemId}: Props) => {
  const {itemIdForUpdate} = useListView()
  const isLoading = useQueryResponseLoading()

  return (
    <>
      <QueryRequestProvider>
        {/* <QueryResponseProvider> */}
        <QueryResponseProvider invoiceId={invoiceId} invoiceItemId={invoiceItemId}>
          <ListViewProvider>
            <>
              <FilterProvider>
                {isLoading && <PageOverlayer />}

                <Header invoiceId={invoiceId} />
                <Table />

                {itemIdForUpdate !== undefined}
              </FilterProvider>
            </>
          </ListViewProvider>
        </QueryResponseProvider>
      </QueryRequestProvider>
    </>
  )
}

export default UsageByPeriodListPage
